export enum SessionCookies {
  accessToken = 'accessToken',
  userName = 'userName',
  needsPasswordChange = 'needsPasswordChange',
  hidePrices = 'hidePrices',
}
